import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  LOGIN_USER_ERROR,
  REGISTER_USER_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  LOGIN_USER_API_SUCCESS,
  SYNC_USER_INFO,
  UPDATE_SELECTED_EMPLOYEE,
  SELECT_ACTIVE_ACCOUNT,

  // Update account users
  fetchContacts,
  fetchMessages,
  fetchChat,
  setChatPhone,
  setVoiceChatPhone,
  fetchVoicemails,
  fetchVoiceChat,
  fetchCustomMessages,
  fetchNotifications,
  fetchAllNotifications,
  fetchPreferences,
  fetchMessagesSuccess,
  fetchUnReadCountData,
  fetchResponseCountData,
  fetchResponsibleListData,
} from "./index";
import {
  apiCall,
  setToStorage,
  removeFromStorage,
  getFromStorage,
} from "../../functions/utils";

export const loginUser = () => ({
  type: LOGIN_USER,
});
export const loginUserSuccess = (data) => {
  return {
    type: LOGIN_USER_SUCCESS,
    payload: data,
  };
};
export const loginUserApiSuccess = (data) => {
  return {
    type: LOGIN_USER_API_SUCCESS,
    payload: data,
  };
};
export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message },
});

export const forgotPassword = (forgotUserMail, history) => ({
  type: FORGOT_PASSWORD,
  payload: { forgotUserMail, history },
});
export const forgotPasswordSuccess = (forgotUserMail) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: forgotUserMail,
});
export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message },
});

export const resetPassword = ({ resetPasswordCode, newPassword, history }) => ({
  type: RESET_PASSWORD,
  payload: { resetPasswordCode, newPassword, history },
});
export const resetPasswordSuccess = (newPassword) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: newPassword,
});
export const resetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: { message },
});

export const changeTwilioStatus = (status) => ({
  type: "TWILIO",
  payload: status,
});

export const registerUser = (user, history) => ({
  type: REGISTER_USER,
  payload: { user, history },
});
export const registerUserSuccess = (user) => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});
export const registerUserError = (message) => ({
  type: REGISTER_USER_ERROR,
  payload: { message },
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

// this should be logout method
export const signoutUser = () => {
  return async (dispatch) => {
    try {
      const res = apiCall(true, "GET", "/api/auth/logout");
      await removeFromStorage("user_id");
      await removeFromStorage("user");
      await removeFromStorage("activeAccount");
      await removeFromStorage("login");
      await removeFromStorage("twilioStatus");
      dispatch(logoutUser());
    } catch (e) {
      console.log("logoutAsync Error", e);
    }
  };
};

export const logoutAsync = (history) => {
  return async (dispatch) => {
    try {
      const res = apiCall(true, "GET", "/api/auth/logout");
      removeFromStorage("user_id");
      removeFromStorage("user");
      removeFromStorage("activeAccount");
      removeFromStorage("login");
      history.push("/");
      dispatch(logoutUser());
    } catch (e) {
      console.log("logoutAsync Error", e);
    }
  };
};

export const loginWithEmailPassword = (data, history) => {
  return async (dispatch) => {
    dispatch(loginUser());
    try {
      const body = {
        email: data.email,
        password: data.password,
      };
      let urlAppends = "/api/auth/login";
      // if( data.is_employee ) urlAppends = "/api/auth/employeeLogin"
      const res = await apiCall(false, "POST", urlAppends, body);

      // Storage
      await setToStorage("user_id", res.data.token);
      await setToStorage("login", JSON.stringify(res.data));

      // dispatch(loginUserApiSuccess(res.data))
      dispatch(getUserInformationAsync(history));
    } catch (e) {
      dispatch(loginUserError("Password do not match!"));
    }
  };
};

export const updateSelectedEmployee = (portal_id) => {
  return {
    type: UPDATE_SELECTED_EMPLOYEE,
    payload: portal_id,
  };
};

export const fetchLatestTwilioStatus = () => {
  return async (dispatch) => {
    try {
      const res = await apiCall(true, "GET", `/api/checkTwilioStatus`);
      if (res?.data?.twilioStatus) {
        dispatch(changeTwilioStatus(res?.data?.twilioStatus));
        await setToStorage("twilioStatus", res?.data?.twilioStatus);
      }
    } catch (e) {
      //  console.log("TWILIO_STATUS_ERR");
    }
  };
};

export const forgotPasswordAsync = (email, history) => {
  // return await auth.sendPasswordResetEmail(email)
  //     .then(user => user)
  //     .catch(error => error);
  return async (dispatch) => {
    dispatch(forgotPassword(email, history));
    try {
      const body = {
        email: email,
      };
      const res = await apiCall(false, "POST", "/api/auth/recovery", body);
      dispatch(forgotPasswordSuccess(email));
    } catch (e) {
      dispatch(forgotPasswordError("AN ERROR OCCURED!"));
    }
  };
};

export const continueLogin = (account_id) => {
  return async (dispatch) => {
    dispatch(getUserInformationAsync(true));
  };
};

export const getUserInformationAsync = (cont = false) => {
  return async (dispatch) => {
    try {
      const res = await apiCall(true, "GET", "/api/auth/me", [], true, false);
      let data = JSON.stringify(res.data);
      await setToStorage(
        "twilioStatus",
        res?.data?.accounts[0]?.twilio_phone_status
      );

      if (res.data.accounts[0].twilio_phone_status != "ready" && !cont) {
        dispatch(changeTwilioStatus(res.data.accounts[0].twilio_phone_status));
      }

      // dispatch(loginUserSuccess(JSON.parse(data)))
      // fff_work
      else {
        if (cont) {
          setToStorage("twilioStatus", "ready");
          dispatch(changeTwilioStatus("ready"));
          await apiCall(true, "POST", "/api/auth/changeTwilioPhoneStatus", {
            account_id: res.data.accounts[0].id,
          });
        }
      }
      await setToStorage("user", data);

      dispatch(fillFromAsync());

      // history.push('/');
    } catch (e) {
      // dispatch(loginUserError("Password do not match!"))
      console.log("getUserInformationAsync Error", e);
    }
  };
};

/*
 * Using for mobile devices only, remove when there is time
 */
export const SyncUserInfo = (data) => {
  return {
    type: SYNC_USER_INFO,
    payload: data,
  };
};

export const UPDATE_ACTIVE_ACCOUNT = (data) => {
  // data: is the id of account to be updated here
  // set/update to storage here as well

  setToStorage("activeAccount", data);

  return {
    type: SELECT_ACTIVE_ACCOUNT,
    payload: data,
  };
};

export const updateActiveAccount = (data) => {
  return async (dispatch, getState) => {
    dispatch(UPDATE_ACTIVE_ACCOUNT(data));
    dispatch(setChatPhone(""));
    dispatch(setVoiceChatPhone(""));
    let { messages } = getState();
    if (data in messages.all_data) {
      dispatch(fetchMessagesSuccess(messages.all_data[data]));
      if (!messages.chat_phone_no) {
        dispatch(setChatPhone(messages.all_data[data].data[0].sender_phone));
        dispatch(fetchChat());
      }
      dispatch(fetchUnReadCountData());
      dispatch(fetchResponseCountData());
      // dispatch(fetchResponsibleListData())
    } else {
      dispatch(fetchMessages());
      dispatch(fetchChat());
    }

    dispatch(fetchVoicemails());
    dispatch(fetchVoiceChat());

    dispatch(fetchContacts());

    dispatch(fetchCustomMessages());

    // console.log("Top Level -- Fetch All Notifications  --- 3");
    // dispatch(fetchAllNotifications())
    dispatch(fetchNotifications());

    dispatch(fetchPreferences());
  };
};

export const fillFromAsync = () => {
  return async (dispatch) => {
    let data = {
      user: JSON.parse(await getFromStorage("user")),
      login: JSON.parse(await getFromStorage("login")),
      activeAccount: await getFromStorage("activeAccount"),
    };
    let accounts = data?.user?.accounts || [];
    if( !accounts ){
        return;
    }
    let activeAccount = 0;
    if (accounts.length) {
      activeAccount = accounts[0]["id"];
    }
    if (
      data["activeAccount"] &&
      accounts.find((x) => x.id == data["activeAccount"])
    ) {
      activeAccount = data["activeAccount"];
    }
    data["activeAccount"] = activeAccount;
    setToStorage("activeAccount", data["activeAccount"]);
    await dispatch(UPDATE_ACTIVE_ACCOUNT(activeAccount));
    await dispatch(SyncUserInfo(data));
  };
};

/*
 * Reset all states here plus API calls plus resetting
 */
export const signOut = () => {};

/*
 * Reset all states here plus API calls plus resetting
 */
export const isAdminUser = () => {
  return (dispatch, getState) => {
    try {
      var target = getState().authUser;
      const { user, activeAccount } = target;
      const { accounts } = user;
      let activeAccountData = accounts.find((x) => x.id == activeAccount);
      if (
        activeAccountData.pivot.role == 1 ||
        activeAccountData.pivot.role == 2
      ) {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  };
};

export const restrictedURLsForBasic = [
  "audit-logs",
  "upcoming-reminders",
  "reminders",
  "employee-management",
];

export const isRestrictedItem = (item) => {
  return (dispatch, getState) => {
    try {
      var target = getState().authUser;
      const { user, activeAccount } = target;
      const { accounts } = user;
      let activeAccountData = accounts.find((x) => x.id == activeAccount);

      if (!isAdminUser() && item.id == "settings") {
        return false;
      } else if (
        activeAccountData.stripe_price_id == 0 &&
        (restrictedURLsForBasic.indexOf(item.to) !== -1 ||
          restrictedURLsForBasic.includes(item.to.replace("/app/", "")))
      ) {
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  };
};
